import React, { useState, useEffect } from "react";

export default function Settings() {
  return <div className="w-full p-2">settings</div>;
}
